<template>
  <base-modal
    :reference="'closeBus_' + bus.id"
    :title="'Cerrar el bus con advertencia'"
    :acceptAction="closeBus"
    :cancelActionText="'Cancelar'"
    :size="'md'"
  >
    <template v-slot:body v-if="show">
      
      <div class="d-block text-center">
        <p>
          El bus que ha solicitado cerrar (<strong>{{bus.name}}</strong>) tiene reservas que están asignadas a otros buses de recogida y/o devolución.
        </p>
        <p>
          Cuando se cierra un bus, este bus cerrado se utiliza para la excursión, la recogida y la devolución. Todo bus de recogida
          y/o devolución que esté vinculado a esta reserva será sobreescrito asignándole el bus que ha solicitado cerrar. 
        </p>

        <p>
          ¿Quiere continuar?
        </p>

      </div>
    </template>

  </base-modal>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import BaseModal from '../../../Excursions/Booking/Modal/BaseModal';

export default {
  components: {
      BaseModal,
  },
  props: {
    bus: {
      type: Object, 
      required: true,
    }
  },
  data() {
    return {
      show: false,
    }
  },
  async mounted() {
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      if ( modalId === 'closeBus_' + this.bus.id ) {
        this.show = true
      }
    })
  },
  methods: {
    async closeBus() {
      const busData = {
        date: this.$store.getters.filterDate,
        group: this.$store.getters.filterGroup,
        bus_type: this.path,
      };

      try {
        await this.$store.dispatch("bookingsBus/closeBus", this.bus.id);
        this.$notify({
          group: "foo",
          title: "Bus cerrado",
          text: "Se ha cerrado el bus seleccionado",
          type: "success",
        })
      } catch (ex) {
        this.error = "Failed to load data";
        this.$notify({
          group: "foo",
          title: "Error al cerrar bus",
          text: "El bus seleccionado no se ha podido cerrar satisfactoriamente",
          type: "error",
        })
      }
      this.$bvModal.hide("closeBus_" + this.bus.id)
    },
  },
  computed: {
    ...mapGetters(["activeTab"]),
    type() {
      return this.activeTab == 'Pickups' ? 'recogidas' : 'excursiones'
    }
  }
};
</script>
